var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocsPaperPlane(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5242 3.31511L3.6248 10.1785C3.01389 10.5318 3.07498 11.4322 3.72573 11.7005L7.44962 13.241V15.9503C7.44962 16.7524 8.45363 17.1004 8.95564 16.4895L10.5679 14.5293L13.9252 15.9158C14.4326 16.1256 15.0063 15.8042 15.0886 15.2597L16.7885 4.18101C16.8974 3.47182 16.1351 2.96185 15.5242 3.31511ZM8.29958 15.9503V13.5917L9.74716 14.1893L8.29958 15.9503ZM14.2493 15.1295L8.77237 12.8665L14.0713 6.60339C14.1988 6.45465 13.9943 6.25278 13.8456 6.38028L7.06448 12.16L4.04978 10.9169L15.9492 4.05086L14.2493 15.1295Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocsPaperPlane);
export default __webpack_public_path__ + "static/media/icon-docs-paper-plane.43b339777cd0820b873a81c50c6f5799.svg";
export { ForwardRef as ReactComponent };